import { useEffect, useState, CSSProperties } from 'react';

export default function PasswordModal({ setIsVerified }: any) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';

    return () => {
      // Re-enable scroll when modal is closed
      document.body.style.overflow = 'auto';
    };
  }, []);

  const handleSubmit = async () => {
    if (password === 'Tork') {
      localStorage.setItem('password_kirei', 'Tork'); // Client-side storage
      setIsVerified(true);
    } else {
      setError('Invalid password');
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h3 className="mb-4">Enter Password</h3>
        <div className="form-group">
          <input
            id="name"
            className="form-control"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />
          <div className="help-block with-errors" />
        </div>

        <button
          className="trk-btn trk-btn--primary mt-4"
          onClick={handleSubmit}
          style={styles.button}
        >
          Submit
        </button>
        {error && <p style={styles.error}>{error}</p>}
      </div>
    </div>
  );
}

const styles: { [key: string]: CSSProperties } = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.8)', // Adjust opacity for better visibility
    backdropFilter: 'blur(10px)', // Apply background blur
    WebkitBackdropFilter: 'blur(10px)', // Safari support
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  modal: {
    background: 'rgba(255, 255, 255, 0.95)', // Make modal slightly transparent
    padding: '40px',
    borderRadius: '8px',
    textAlign: 'center',
  },
  // input: {
  //   width: "90%",
  //   padding: "10px",
  //   margin: "10px 0",
  //   border: "1px solid #ccc",
  //   borderRadius: "4px",
  // },

  error: { color: 'red', marginTop: '10px' },
};
